import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../../../core/Icon';

export const StyledParagraphProyects = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('22px')};
  margin: ${rem('20px')} 0 0 ${rem('30px')};
`;

export const StyleIconProyects = styled(Icon)`
  background-color: ${props => props.theme.colors.success};
  border-radius: 50%;
  float: left;
  padding: ${rem('6px')};
`;

export const StyleIconPending = StyleIconProyects.extend`
  background-color: ${props => props.theme.colors.secondary};
  padding: ${rem('4px')};
`;

export const StyledProjectLabel = styled.label`
  display: block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin-top: ${rem('30px')};
  text-transform: uppercase;
`;
